import { useQuery } from "@tanstack/react-query";

import { queryKeyMap } from "@/features/query-client";

import { fetchOneLenderApplication } from "../../api";

export const useGetLenderApplicationDetailQuery = (
  lenderCompanyId: number,
  lenderApplicationId: number,
) => {
  return useQuery({
    queryKey: queryKeyMap.getLenderApplication(lenderApplicationId),
    queryFn: async () => {
      return await fetchOneLenderApplication(
        lenderCompanyId,
        lenderApplicationId,
      );
    },
  });
};
